import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { ArrowLeft, ChevronDown } from 'lucide-react';

const FAQ_DATA = {
  fr: [
    {
      q: "Comment fonctionne MyErotika ?",
      a: "MyErotika vous permet de discuter avec des personnages virtuels dotés d'une intelligence artificielle avancée. Choisissez un genre, un personnage et un niveau d'intensité, puis commencez à discuter."
    },
    {
      q: "Qu'est-ce que les niveaux d'intensité ?",
      a: "Il y a 5 niveaux d'intensité, de \"Romantique\" (flirt léger) à \"MyErotika\" (conversations intimes). Vous débloquez les niveaux suivants en discutant ou en les achetant directement."
    },
    {
      q: "Comment débloquer un nouveau niveau ?",
      a: "Deux options : discutez suffisamment avec un personnage pour le débloquer automatiquement (progression gratuite), ou achetez-le directement pour 0,99 \u20AC au lieu de 1,99 \u20AC (prix de lancement, paiement unique) dans les paramètres du chat."
    },
    {
      q: "Qu'est-ce que l'abonnement illimité ?",
      a: "Pour 4,99 \u20AC/mois au lieu de 9,99 \u20AC/mois (prix de lancement), vous débloquez tous les personnages et tous les niveaux d'intensité, sans restriction."
    },
    {
      q: "Le mode invité, c'est quoi ?",
      a: "Le mode invité vous permet d'utiliser l'application sans créer de compte. Attention : votre progression ne sera pas sauvegardée. Vous pouvez effectuer des achats, mais ils seront perdus si vous n'avez pas de compte."
    },
    {
      q: "Mes conversations sont-elles privées ?",
      a: "Oui, absolument. Vos conversations sont chiffrées et ne sont accessibles que par vous. Nous ne partageons aucune donnée personnelle."
    },
    {
      q: "Comment activer la synthèse vocale ?",
      a: "Dans les paramètres du chat (icône roue crantée en haut à droite), activez l'option \"Synthèse vocale\". Les réponses de votre personnage seront alors lues à voix haute."
    },
    {
      q: "Puis-je supprimer mon compte ?",
      a: "Oui, rendez-vous dans les paramètres de votre compte ou contactez-nous à miralis-app@outlook.com pour une suppression complète."
    },
    {
      q: "Comment changer la longueur des réponses ?",
      a: "Dans les paramètres du chat, vous pouvez choisir entre des réponses courtes, moyennes ou longues selon vos préférences."
    }
  ],
  en: [
    {
      q: "How does MyErotika work?",
      a: "MyErotika lets you chat with virtual characters powered by advanced AI. Choose a gender, a character and an intensity level, then start chatting."
    },
    {
      q: "What are intensity levels?",
      a: "There are 5 intensity levels, from \"Romantic\" (light flirting) to \"MyErotika\" (intimate conversations). You unlock the next levels by chatting or by purchasing them directly."
    },
    {
      q: "How do I unlock a new level?",
      a: "Two options: chat enough with a character to unlock it automatically (free progression), or buy it directly for \u20AC0.99 instead of \u20AC1.99 (launch price, one-time payment) in the chat settings."
    },
    {
      q: "What is the unlimited subscription?",
      a: "For \u20AC4.99/month instead of \u20AC9.99/month (launch price), you unlock all characters and all intensity levels, with no restrictions."
    },
    {
      q: "What is guest mode?",
      a: "Guest mode lets you use the app without creating an account. Note: your progress won't be saved. You can make purchases, but they'll be lost without an account."
    },
    {
      q: "Are my conversations private?",
      a: "Yes, absolutely. Your conversations are encrypted and only accessible by you. We don't share any personal data."
    },
    {
      q: "How do I enable text-to-speech?",
      a: "In the chat settings (gear icon top right), enable the \"Text-to-speech\" option. Your character's responses will then be read aloud."
    },
    {
      q: "Can I delete my account?",
      a: "Yes, go to your account settings or contact us at miralis-app@outlook.com for complete deletion."
    },
    {
      q: "How do I change response length?",
      a: "In the chat settings, you can choose between short, medium or long responses according to your preferences."
    }
  ],
  es: [
    { q: "¿Cómo funciona MyErotika?", a: "MyErotika te permite chatear con personajes virtuales con IA avanzada. Elige un género, un personaje y un nivel de intensidad, luego empieza a chatear." },
    { q: "¿Qué son los niveles de intensidad?", a: "Hay 5 niveles, de \"Romántico\" a \"MyErotika\". Desbloquéalos chateando o comprándolos directamente." },
    { q: "¿Cómo desbloquear un nuevo nivel?", a: "Dos opciones: chatea lo suficiente para desbloquearlo gratis, o cómpralo por 0,99 \u20AC en lugar de 1,99 \u20AC (precio de lanzamiento, pago único)." },
    { q: "¿Qué es la suscripción ilimitada?", a: "Por 4,99 \u20AC/mes en lugar de 9,99 \u20AC/mes (precio de lanzamiento), desbloqueas todos los personajes y niveles sin restricción." },
    { q: "¿Qué es el modo invitado?", a: "El modo invitado te permite usar la app sin cuenta. Atención: tu progreso no se guardará." },
    { q: "¿Mis conversaciones son privadas?", a: "Sí, absolutamente. Tus conversaciones están cifradas y solo tú puedes acceder a ellas." },
    { q: "¿Cómo activo la síntesis de voz?", a: "En los ajustes del chat (icono de engranaje arriba a la derecha), activa \"Síntesis de voz\"." },
    { q: "¿Puedo eliminar mi cuenta?", a: "Sí, contacta a miralis-app@outlook.com para una eliminación completa." },
    { q: "¿Cómo cambiar la longitud de respuestas?", a: "En los ajustes del chat, puedes elegir entre respuestas cortas, medianas o largas." }
  ],
  de: [
    { q: "Wie funktioniert MyErotika?", a: "Mit MyErotika kannst du mit virtuellen Charakteren mit fortschrittlicher KI chatten. Wähle ein Geschlecht, einen Charakter und eine Intensitätsstufe." },
    { q: "Was sind die Intensitätsstufen?", a: "Es gibt 5 Stufen, von \"Romantisch\" bis \"MyErotika\". Schalte sie durch Chatten oder direkten Kauf frei." },
    { q: "Wie schalte ich eine neue Stufe frei?", a: "Zwei Optionen: Chatte genug, um sie kostenlos freizuschalten, oder kaufe sie für 0,99 \u20AC statt 1,99 \u20AC (Einführungspreis, einmalige Zahlung)." },
    { q: "Was ist das unbegrenzte Abo?", a: "Für 4,99 \u20AC/Monat statt 9,99 \u20AC/Monat (Einführungspreis) schaltest du alle Charaktere und Stufen frei." },
    { q: "Was ist der Gastmodus?", a: "Der Gastmodus ermöglicht die Nutzung ohne Konto. Achtung: Dein Fortschritt wird nicht gespeichert." },
    { q: "Sind meine Gespräche privat?", a: "Ja, absolut. Deine Gespräche sind verschlüsselt und nur für dich zugänglich." },
    { q: "Wie aktiviere ich die Sprachsynthese?", a: "In den Chat-Einstellungen (Zahnradsymbol oben rechts), aktiviere \"Sprachsynthese\"." },
    { q: "Kann ich mein Konto löschen?", a: "Ja, kontaktiere miralis-app@outlook.com für eine vollständige Löschung." },
    { q: "Wie ändere ich die Antwortlänge?", a: "In den Chat-Einstellungen kannst du zwischen kurzen, mittleren oder langen Antworten wählen." }
  ],
  pt: [
    { q: "Como funciona o MyErotika?", a: "O MyErotika permite-lhe conversar com personagens virtuais com IA avançada. Escolha um género, um personagem e um nível de intensidade." },
    { q: "O que são os níveis de intensidade?", a: "Existem 5 níveis, de \"Romântico\" a \"MyErotika\". Desbloqueie-os conversando ou comprando diretamente." },
    { q: "Como desbloquear um novo nível?", a: "Duas opções: converse o suficiente para desbloquear gratuitamente, ou compre por 0,99 \u20AC em vez de 1,99 \u20AC (preço de lançamento, pagamento único)." },
    { q: "O que é a assinatura ilimitada?", a: "Por 4,99 \u20AC/mês em vez de 9,99 \u20AC/mês (preço de lançamento), desbloqueia todos os personagens e níveis." },
    { q: "O que é o modo convidado?", a: "O modo convidado permite usar a app sem conta. Atenção: o seu progresso não será guardado." },
    { q: "As minhas conversas são privadas?", a: "Sim, absolutamente. As suas conversas são encriptadas e apenas acessíveis por si." },
    { q: "Como ativo a síntese de voz?", a: "Nas definições do chat (ícone de engrenagem no canto superior direito), ative \"Síntese de voz\"." },
    { q: "Posso apagar a minha conta?", a: "Sim, contacte miralis-app@outlook.com para uma eliminação completa." },
    { q: "Como mudar o comprimento das respostas?", a: "Nas definições do chat, pode escolher entre respostas curtas, médias ou longas." }
  ]
};

export default function FaqPage() {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const [openIndex, setOpenIndex] = useState(null);
  const faqs = FAQ_DATA[language] || FAQ_DATA.fr;

  return (
    <div className="min-h-screen bg-velvet-bg px-4 py-8 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-velvet-bg via-velvet-bg to-purple-dark/20" />
      <div className="absolute top-1/4 -left-32 w-64 h-64 bg-purple-main/20 rounded-full blur-3xl" />
      
      <div className="relative z-10 max-w-2xl mx-auto">
        <button 
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-2 text-velvet_text-secondary hover:text-velvet_text-accent mb-8 transition-colors"
          data-testid="faq-back-button"
        >
          <ArrowLeft size={20} />
          {language === 'fr' ? 'Retour' : language === 'es' ? 'Volver' : language === 'de' ? 'Zurück' : language === 'pt' ? 'Voltar' : 'Back'}
        </button>
        
        <h1 className="font-heading text-3xl text-velvet_text-primary mb-2" data-testid="faq-title">
          {language === 'fr' ? 'Questions fréquentes' : language === 'es' ? 'Preguntas frecuentes' : language === 'de' ? 'Häufige Fragen' : language === 'pt' ? 'Perguntas frequentes' : 'Frequently Asked Questions'}
        </h1>
        <p className="text-velvet_text-secondary mb-8">
          {language === 'fr' ? 'Tout ce que vous devez savoir sur MyErotika' : language === 'es' ? 'Todo lo que necesitas saber sobre MyErotika' : language === 'de' ? 'Alles, was Sie über MyErotika wissen müssen' : language === 'pt' ? 'Tudo o que precisa saber sobre MyErotika' : 'Everything you need to know about MyErotika'}
        </p>
        
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className="glass rounded-xl overflow-hidden"
              data-testid={`faq-item-${index}`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-4 text-left text-velvet_text-primary hover:text-velvet_text-accent transition-colors"
              >
                <span className="font-medium pr-4">{faq.q}</span>
                <ChevronDown 
                  size={18} 
                  className={`shrink-0 text-velvet_text-secondary transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`} 
                />
              </button>
              {openIndex === index && (
                <div className="px-4 pb-4 text-velvet_text-secondary text-sm leading-relaxed animate-slideUp">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
